import instance from "./Instance/index.js";

export const createAnswer = async (values) => {
  try {
    const response = await instance.post(`/answers`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getCorrectAnswers = async () => {
  try {
    const response = await instance.get(`/answers/correct`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUsercategories = async (id) => {
  try {
    const response = await instance.get(`/answers/user/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getIncorrectAnswers = async () => {
  try {
    const response = await instance.get(`/answers/incorrect`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateAnswer = async (values) => {
  try {
    const response = await instance.patch(`/answers/update`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteAnswer = async (id) => {
  try {
    const response = await instance.delete(`/answers/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
